import React, { ReactNode } from "react";

import { Layout } from "react-grid-layout";
import { IntlShape } from "react-intl";

import User from "@mapmycustomers/shared/types/User";

import GoalType from "@app/enum/dashboard/GoalType";
import NoTimeRangeFormComponent from "@app/scene/dashboard/components/cards/common/NoTimeRangeFormComponent";
import CardUiDescriptor from "@app/scene/dashboard/types/CardUiDescriptor";
import ActivitiesOverdueCardConfiguration from "@app/types/dashboard/cards/activitiesOverdue/ActivitiesOverdueCardConfiguration";
import ActivitiesOverdueViewState from "@app/types/dashboard/cards/activitiesOverdue/ActivitiesOverdueViewState";
import Scope from "@app/types/dashboard/Scope";
import { userDisplayName } from "@app/util/formatters";

import { GRID_WIDTH } from "../../DashboardContent/util/consts";
import GoalDetailsFormComponent from "../common/GoalDetailsFormComponent";

import CardContentComponent from "./CardContentComponent";
import CriteriaFormComponent from "./CriteriaFormComponent";
import messages from "./messages";

const activitiesOverdueCard: CardUiDescriptor<ActivitiesOverdueCardConfiguration> = {
  CardContentComponent,
  CriteriaFormComponent,
  DateRangeFormComponent: NoTimeRangeFormComponent,
  getCardDimensions({ viewState }): Pick<Layout, "h" | "w"> {
    const dimensions = {
      h: 2,
      w: (viewState as ActivitiesOverdueViewState).fullWidth ? GRID_WIDTH / 2 : 2,
    };
    return dimensions;
  },
  getCardPlainTitle(intl): string {
    return intl.formatMessage(messages.cardTitle) as string;
  },
  getGoalDescription(intl: IntlShape, context: { scope: Scope }, users: User[]): ReactNode {
    const { scope } = context;
    if (scope.userId) {
      const user = users.find(({ id }) => id === scope.userId);
      return intl.formatMessage(messages.userGoal, {
        b: (text: ReactNode[]) => <b>{text}</b>,
        user: user ? userDisplayName(user) : intl.formatMessage(messages.user),
      });
    }
    return intl.formatMessage(scope.teamId ? messages.teamGoal : messages.orgGoal, {
      b: (text: ReactNode[]) => <b>{text}</b>,
    });
  },
  getGoalType() {
    return { format: "amount", goalType: GoalType.MAX_GOAL };
  },
  getModalTitle(intl: IntlShape): ReactNode {
    return intl.formatMessage(messages.modalTitle);
  },
  GoalDetailsComponent: GoalDetailsFormComponent,
  get PreferencesFormComponent() {
    // this card has no preferences as it doesn't have historic data
    return () => null;
  },
};

export default activitiesOverdueCard;
